import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const WarehouseInventoryDetailRBAC = {
  pageID: 'fd601ffd6f8da335cd244620e27aab45',
  elementID: {
    BtnPrintQR: '9fba392dbacb94f49f5ed0c11fc658b1',
    BtnUpdateStatus: 'd63d8d4ac64d3f7df2b77b30eb9cb412',
    BtnStockInSearch: '478bc0ba8fd7985074c65f017ba1a532',
    BtnUpdateExpiryDate: '18a85817df3db2bc1fa343f1f95fa839',
    BtnMoveSKU: '5d552cd91ecb94f49fa14be8fb6bd4b7',
    BtnMovePallet: '83e9455fd50743b73fb103fd6428da5a',
    BtnAddProduct: 'e94e8831090729caaacae286db898a11',
  },
} as const

export const useRBACWarehouseInventoryDetailPage = createUseRBAC(
  WarehouseInventoryDetailRBAC.elementID,
)

export type UseRBACWarehouseInventoryDetailPageType = ReturnType<
  typeof useRBACWarehouseInventoryDetailPage
>
